import type { ExtensionConfig } from '@goto/shell'

const contactCenterSupervisorBaseUrl = '/experiences/cc-supervisor/'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/cc-supervisor',
  url: new URL(`${contactCenterSupervisorBaseUrl}@ucc/cc-supervisor-extension.mjs`, location.origin),
  esModule: true,
}

export default extensionConfig
